<template>
    <div class="bg-0A1129 text-white min-vh-100">
        <!-- Main Header -->
        <Mainlayout />
    
        <div class="container-fluid pt-5">
            <br /> <br /> <br />
            <div class="row p-3">
                <div class="col-md-7 mb-4">
                    <p class="custom-16px-400 text-white">Kami memberi jaminan untuk menguasai bahan dengan tutor terbaik dalam bidang mereka.

</p>
                    <h2 class="mb-3 custom-52px-600 text-left">Berhubung dengan <strong style="color:#4d9ae0">guru terbaik </strong>kami dalam setiap pelajaran anda</h2>
                </div>
                <div class="col-md-5 mb-4">
                    <CRow>
                        <CCol sm="2" style="border-right:1px solid #E0E0E0">
                            <img src="../assets/img/flyhigh/Circle.png" width="30px" />
                        </CCol>
                        <CCol sm="3">
                            <h3 class="custom-24px-500 text-white">100+</h3>
                            <p class="custom-12px-400 font-color-939393">Guru Berpengalaman</p>
                        </CCol>
                        <CCol sm="3">
                            <h3 class="custom-24px-500 text-white">200+</h3>
                            <p class="custom-12px-400 font-color-939393">Video Dihasilkan</p>
                        </CCol>
                        <CCol sm="3">
                            <h3 class="custom-24px-500 text-white">500+</h3>
                            <p class="custom-12px-400 font-color-939393">Pelajar Bergraduasi</p>
                        </CCol>
    
                    </CRow>
                    <CCol sm="12">
                        <p class="custom-12px-400 font-color-939393 mt-2">
                            Anda akan bertemu dengan guru terbaik yang bukan sahaja bersedia untuk membimbing anda tetapi juga bersemangat untuk membantu anda setiap langkah sehingga anda mencapai matlamat anda dan merealisasikan potensi penuh anda.
                        </p>
                        <div class="input-wrapper">
                            <input type="text" placeholder="Cari Guru...." class="custom-input-app" style="border:none" />
                            <CButton class="browse-btn">Cari Guru</CButton>
                        </div>
                    </CCol>
    
                </div>
                <CCol sm="6">
                    <CRow>
                        <CCol sm="6">
                            <img src="../assets/img/flyhigh/t1.png" style="max-width:100%" />
                        </CCol>
                        <CCol sm="6">
                            <img src="../assets/img/flyhigh/t2.png" style="max-width:100%" />
                        </CCol>
                    </CRow>
                </CCol>
                <CCol sm="6">
                    <h3 class="custom-32px-600 text-white">Berpengalaman & Dipercayai</h3>
                    <p class="custom-16px-400 font-color-939393">Guru kami berpengalaman dan telah melalui banyak pilihan sebelum membuka kelas.</p>
                    <CRow class="mt-5">
                        <CCol sm="6">
                            <img src="../assets/img/flyhigh/t3.png" style="max-width:100%" />
                        </CCol>
                        <CCol sm="6">
                            <img src="../assets/img/flyhigh/t4.png" style="max-width:100%" />
                        </CCol>
                    </CRow>
                </CCol>
                <CCol sm="12" class="mt-5">
                    <h3 class="custom-32px-600 text-white mb-4">Guru Terbaik Kami</h3>
                    <CRow>
                        <CCol sm="3">
                            <img src="../assets/img/flyhigh/te1.png" style="max-width:100%" class="border-20px" />
                            <h3 class="custom-24px-500 text-white mt-3">Cikgu Hanis</h3>
                            <h4 class="font-color-939393">Mathematics teacher</h4>
                            <label class="custom-32px-600">5.0</label><label class="custom-16px-400 font-color-939393"></label>/312 Review Positif
                            <p class="custom-14px-400">A teacher with high dedication and a vision to educate many people</p>
                        </CCol>
                        <CCol sm="3">
                            <img src="../assets/img/flyhigh/te2.png" style="max-width:100%" class="border-20px" />
                            <h3 class="custom-24px-500 text-white mt-3">Teacher Hazwan</h3>
                            <h4 class="font-color-939393">Science teacher</h4>
                            <label class="custom-32px-600">5.0</label><label class="custom-16px-400 font-color-939393"></label>/312 Review Positif
                            <p class="custom-14px-400">An inspiring educator who brings passion and curiosity to her classroom.</p>
                        </CCol>
                      
                      
                        <CCol sm="3">
                            <img src="../assets/img/flyhigh/te6.png" style="max-width:100%" class="border-20px" />
                            <h3 class="custom-24px-500 text-white mt-3">Cikgu Shukry</h3>
                            <h4 class="font-color-939393">Biology instructor</h4>
                            <label class="custom-32px-600">5.0</label><label class="custom-16px-400 font-color-939393"></label>/312 Review Positif
                            <p class="custom-14px-400">Dynamic and enthusiastic about nurturing a sense of wonder in her students.</p>
                        </CCol>
                        <CCol sm="3">
                            <img src="../assets/img/flyhigh/te7.png" style="max-width:100%" class="border-20px" />
                            <h3 class="custom-24px-500 text-white mt-3">Cikgu Faiz</h3>
                            <h4 class="font-color-939393">Social Studies teacher</h4>
                            <label class="custom-32px-600">5.0</label><label class="custom-16px-400 font-color-939393"></label>/312 Review Positif
                            <p class="custom-14px-400">Motivates students with engaging narratives and insightful historical perspec</p>
                        </CCol>
                       
                        <CCol sm="12">
                            <div class="text-center mt-5">
                            <CButton class="bg-1796FD custom-padding text-white" style="margin:0 auto">Lihat Lagi</CButton>
                        </div>
                        </CCol>
                       
                       
                    </CRow>
    
                </CCol>

                <CCol sm="12" class="mt-5 mb-5">
                    <h3 class="text-gradient-blue custom-50px-600">Jom Cari Guru untuk anda</h3>
                    <h4 class="custom-14px-600 text-white">Belajar daripada pakar dan serap semua ilmu yang bermanafaat untuk anda</h4>
                    <div class="text-center">
                        <img src="../assets/img/flyhigh/imgteacher.png" style="max-width:100%"/>
                    </div>
                </CCol>
    
            </div>
        </div>

        <Footer />
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

  import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import Mainlayout from "../containers/AllHeader.vue";
import Footer from "@/components/Footer.vue";

export default {
    name: "FlyHighHome",
    components: {
        Mainlayout,
        Footer,
        Carousel3d,
        Slide,

    },
    data() {
        return {

        };
    },
    computed: {
        sliderStyle() {
            let slidesPerView = 1; // Default for mobile

            if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                slidesPerView = 2; // Tablet (2 per slide)
            } else if (window.innerWidth >= 1024) {
                slidesPerView = 2; // Desktop (3 per slide)
            }

            return {
                transform: `translateX(-${(this.step - 1) * (100 / slidesPerView)}%)`,
                transition: 'transform 0.5s ease-in-out'
            };
        },
    },

    methods: {

    }
};
</script>
  